import { computed, defineComponent } from '@vue/composition-api';
import { Popover } from '@/components/Popover';
export default defineComponent({
    components: {
        Popover,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        displayProperty: {
            type: String,
            required: true,
        },
        countLabel: {
            type: String,
            required: true,
        },
        getItemKey: {
            type: Function,
            default(item, index) {
                return (item.id ||
                    (item.place && item.place.id) ||
                    (item.centralCost && item.centralCost.id) ||
                    String(index));
            },
        },
    },
    setup(props) {
        const itemsCount = computed(() => props.items.length);
        const contractedItem = computed(() => props.items.find((item) => item.status === 'in-contract'));
        const getDisplayValue = (item) => {
            const keys = props.displayProperty.split('.');
            let value = item;
            for (const key of keys) {
                value = value && value[key];
                if (value === undefined || value === null)
                    break;
            }
            return value || '-';
        };
        return {
            itemsCount,
            getDisplayValue,
            contractedItem,
        };
    },
});
